// extracted by mini-css-extract-plugin
module.exports =  {"container":"OIp3geA4hSDzBMLGyIao","list":"pXNpVxfegDfl9uEEXXVT"};